import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { FiMail } from "react-icons/fi";
import { motion } from "framer-motion";

const { REACT_APP_BACKEND_URL } = process.env;

const InputField = ({ icon: Icon, ...props }) => (
  <div className="relative">
    <input
      {...props}
      className="w-full px-4 py-3 pl-12 bg-gray-700 bg-opacity-50 text-white placeholder-gray-400 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition duration-300"
    />
    <Icon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
  </div>
);

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${REACT_APP_BACKEND_URL}/api/auth/request-password-reset`,
        { email }
      );
      toast.success(res.data.msg);
    } catch (err) {
      console.error(err.response.data);
      toast.error(err.response.data.msg || "Failed to send reset email 🚫🚫");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg shadow-2xl rounded-2xl p-8 w-full max-w-md"
      >
        <h2 className="text-3xl font-bold mb-8 text-center text-white">
          Forgot Password
        </h2>
        <form onSubmit={onSubmit} className="space-y-6">
          <InputField
            icon={FiMail}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <motion.button
            whileHover={{
              scale: 1.05,
              boxShadow: "0 0 15px rgba(59, 130, 246, 0.5)",
            }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white py-3 px-4 rounded-lg font-semibold text-lg shadow-lg hover:from-blue-600 hover:to-indigo-700 transition duration-300"
          >
            Send Reset Link
          </motion.button>
        </form>
        <div className="text-center mt-6">
          <Link
            to="/login"
            className="text-gray-300 font-semibold hover:underline hover:text-gray-200 transition duration-300"
          >
            Back to Login
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;